const MuiFormControlLabel = (palette) => ({
  label: {
    fontSize: 12,
    color: palette.text.secondary,
  },
});

export default MuiFormControlLabel;
